module.exports = __webpack_public_path__ + "2020celebration/img/travel-l.f9db0626.png";